import { render } from "./UpdateMultipleCharges.vue?vue&type=template&id=3d137d98"
import script from "./UpdateMultipleCharges.vue?vue&type=script&lang=js"
export * from "./UpdateMultipleCharges.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__